import { render, staticRenderFns } from "./PropertyTable.vue?vue&type=template&id=ec825ce2&"
import script from "./PropertyTable.vue?vue&type=script&lang=js&"
export * from "./PropertyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/pp-weberbuero-50965/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec825ce2')) {
      api.createRecord('ec825ce2', component.options)
    } else {
      api.reload('ec825ce2', component.options)
    }
    module.hot.accept("./PropertyTable.vue?vue&type=template&id=ec825ce2&", function () {
      api.rerender('ec825ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/PropertyTable.vue"
export default component.exports